"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreePicker = void 0;
const Utilities_1 = require("../../../javascript/Utilities");
const ExternalInput_1 = require("./ExternalInput");
const Base_1 = require("../../../model/Base");
/**
* Picker for self-ref FT
*/
class TreePicker extends ExternalInput_1.ExternalInput {
    constructor(controlColl, currentInstance, methodName) {
        super(controlColl, currentInstance, methodName);
        this.methodName = methodName;
        this.m_postFetchCheckedMap = {};
        this.windowContentCssClass = "eiTreePicker";
        this.windowActions = ["Maximize", "Close"];
    }
    destroyWidgets() {
        this.m_$treeView.data("kendoTreeView").destroy();
    }
    getUpdatedInstance() {
        let that = this;
        let instance = this.currentInstance;
        let checkedIds = this.getRawCheckedIds();
        let convertedArray = $.map(this.getRawCheckedNames(), function (elem) {
            return that.input.convertBack(elem, true);
        });
        if (!that.multiValue) {
            instance.items[this.input.field.presentedField].value = (checkedIds.length ? checkedIds[0] : undefined);
            instance.items[this.input.field.fieldName].value = (convertedArray.length ? convertedArray[0] : undefined);
        }
        else {
            instance.items[this.input.field.presentedField].value = checkedIds;
            instance.items[this.input.field.fieldName].value = convertedArray;
        }
        return Promise.resolve(instance);
    }
    initWindowContents() {
        let that = this;
        let treePickerMarkup = require("../../../templates/externalInputs/TreePicker.html");
        let template = kendo.template(treePickerMarkup);
        let idData = {
            windowId: that.windowData.guid,
            searchLabelText: Utilities_1.synUtil.Strings.getValue("searchlabel", "Search"),
            selectedItemsText: Utilities_1.synUtil.Strings.getValue("dynpselecteditems", "Selected items"),
        };
        let result = template(idData);
        that.widgetContainer.html(result);
        let splitter = that.widgetContainer.find(".splitter");
        splitter.kendoSplitter({
            orientation: "vertical",
            panes: [
                {
                    size: "20px",
                    resizable: false,
                    scrollable: false
                }, {
                    resizable: false,
                    scrollable: false
                }, {
                    size: "20px",
                    resizable: false,
                    scrollable: false
                },
            ]
        });
        splitter.find(".k-splitbar").css("display", "none");
        that.widgetContainer.find(".searchTextBox").on('change keyup paste mouseup', function () {
            let data = $(this).data("lastValue");
            if ($(this).val() !== data) {
                $(this).data("lastValue", $(this).val());
                if (!data)
                    $(this).removeClass("notFound");
                else {
                    if (that.selectByContainedText(data))
                        $(this).removeClass("notFound");
                    else
                        $(this).addClass("notFound");
                }
            }
        });
        let updateTextBox = function () {
            that.widgetContainer.find(".currentSelTextBox")
                .val(that.getRawCheckedNames().join());
        };
        let checkType = (that.multiValue ? "checkbox" : "radio");
        let processCore = function (node) {
            node.disabled = that.mode === Base_1.PropertyPageMode.View || node.isAbstract;
            if (node.fetchedItems)
                $.each(node.fetchedItems, function (idx, childNode) {
                    processCore(childNode);
                });
        };
        let process = function (nodes) {
            $.each(nodes, function (idx, node) {
                processCore(node);
            });
        };
        that.m_$treeView = that.widgetContainer.find(".ftTree");
        that.m_$treeView.kendoTreeView({
            // animation: false,
            dataTextField: "name",
            template: "<input class='ftCheckBox' #= item.disabled?  \'disabled=\\'disabled\\'\' : \'\' # name='input_"
                + that.windowData.guid
                + "' data-ftid='#= item.id #' id='cb_#= item.id #_" + that.windowData.guid + "' type='"
                + checkType
                + "' #= item.isChecked?  \'checked=\\'checked\\'\' : \'\' #/><label class='ftCbLabel #= item.disabled?  \'k-state-disabled\' : \'\' #' for='cb_#= item.id #'>#: item."
                + that.input.field.fieldName.substring(that.input.field.fieldName.indexOf(".") + 1)
                + "#</label>",
            expand(e) {
                that.fixCheckboxCheckedState(e.sender, e.node);
            },
            collapse(e) {
                that.fixCheckboxCheckedState(e.sender, e.node);
            },
            dataBound(e) {
                updateTextBox();
                if (!that.m_$treeView.data("kendoTreeView").initiallyScrolled) {
                    let ids = that.getRawCheckedIds();
                    if (ids.length) {
                        that.selectById(ids[0]);
                        that.scrollToId(ids[0]);
                        that.m_$treeView.data("kendoTreeView").initiallyScrolled = true;
                    }
                }
                // Fix for the first node having the selected style by default after disabling the select function
                that.widgetContainer.find("span.k-state-selected").removeClass("k-state-selected");
                // Fix for tree nodes changing selected state after fetching children (see also
                // fixCheckboxCheckedState())
                if (typeof e.node !== "undefined") {
                    const dataItem = e.sender.dataItem(e.node);
                    const postFetchChecked = that.m_postFetchCheckedMap[dataItem.id.toString()];
                    if (typeof postFetchChecked !== "undefined") {
                        const checkBoxId = that.getCheckBoxId($(e.node[0].firstChild));
                        delete that.m_postFetchCheckedMap[dataItem.id.toString()];
                        window.setTimeout(() => {
                            $("#" + checkBoxId).prop("checked", postFetchChecked);
                        }, 0);
                    }
                }
            },
            select(e) {
                e.preventDefault();
                return false;
            },
            dataSource: new kendo.data.HierarchicalDataSource({
                transport: {
                    read(options) {
                        let fetched = false;
                        that.storeCheckedState();
                        let instance = that.currentInstance.clone();
                        // For search mode, this external input can only appear inside an extended search dialog.
                        // Thus, the presented value of the current instance is a FILTER STRING!
                        // But for each search constraint inside the extended search dialog, we want the tree picker
                        // to be generated only for the selected value inside the respective SelfRef-FT combo.
                        // Example: The search constraint is 1||<>2. This is the value the presented field of the instance
                        //          currently holds. When opening the extended search dialog, there will be two search
                        //          constraints:
                        //             1.) (equals)1
                        //             2.) (or)(not equal)2
                        //          Obviously, we cannot pass the presented field (1||<>2) to the SelfrefFT webservice
                        //          to initialize each of the treepickers. Instead we pass the (presented) value of the
                        //          FT combobox next to the tree picker button.
                        if (that.mode === Base_1.PropertyPageMode.Search)
                            instance.items[that.controlColl.Input.field.presentedField].value = that.controlColl.Input.getIdString();
                        let rqData = {
                            controlName: that.controlKey,
                            mode: that.mode,
                            instance: JSON.stringify(instance.toJSON())
                        };
                        if (options.data.id) {
                            let item = that.m_$treeView.data("kendoTreeView").dataSource.get(options.data.id);
                            if (item.childrenFetched) {
                                options.success(item.fetchedItems);
                                fetched = true;
                            }
                            else
                                rqData.parentNode = options.data.id;
                        }
                        if (!fetched) {
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: Utilities_1.synUtil.getWSUrl("PropertypageSelfRefFTEntries"),
                                requestData: JSON.stringify(rqData),
                                done(data) {
                                    process(data);
                                    options.success(data);
                                    // remove (+) icon if no children exist
                                    if (!data.length) {
                                        let treeNodeDOM = that.m_$treeView.find(".k-i-loading").parent();
                                        treeNodeDOM.find(".k-i-expand").remove();
                                        treeNodeDOM.closest('li').addClass('synNoChildren');
                                    }
                                    // expand all prefetched nodes
                                    let treeview = that.m_$treeView.data("kendoTreeView");
                                    let expandRecursive = function (dataItem) {
                                        if (dataItem.childrenFetched) {
                                            treeview.expand(treeview.findByUid(dataItem.uid));
                                            $.each(dataItem.items, function (idx, subItem) {
                                                expandRecursive(subItem);
                                            });
                                        }
                                    };
                                    if (!options.data.id)
                                        $.each(treeview.dataSource.data(), function (idx, rootItem) {
                                            expandRecursive(rootItem);
                                        });
                                    that.restoreCheckedState();
                                }
                            });
                        }
                    }
                },
                schema: {
                    model: {
                        id: "id",
                        hasChildren: "hasChildren"
                    }
                }
            })
        });
        that.m_$treeView.data("kendoTreeView").initiallyScrolled = false;
        that.m_$treeView.on("change", "input.ftCheckBox", updateTextBox);
        let dialog = that.windowData.windowDiv.data("kendoWindow");
        dialog.setOptions({
            resizable: true,
            minWidth: that.windowMinWidth == undefined ? that.windowWidth : that.windowMinWidth,
            minHeight: that.windowMinHeight == undefined ? that.windowHeight : that.windowMinHeight
        });
        return Promise.resolve();
    }
    //#region Private functions
    storeCheckedState() {
        this.m_$treeView.data("checkedIds", this.getRawCheckedIds());
    }
    fixCheckboxCheckedState(tv, treeViewNodeElement) {
        // There seems to be a bug in the current version of kendo UI where when you deselect an intially selected
        // node in the TreePicker and expand/collapse it, it will be re-selected even though it just was deselected.
        // This workaround stores the correct selection state (before expand/collapse takes place) and restores it
        // after expand/collapse has concluded (hence setTimeout()). This introduces a short flickering of the
        // associated checkbox, which cannot be avoided
        const checkBoxId = this.getCheckBoxId($(treeViewNodeElement.firstChild));
        const currentlyChecked = $("#" + checkBoxId).prop("checked");
        const dataItem = tv.dataItem(treeViewNodeElement);
        if (!dataItem.loaded())
            this.m_postFetchCheckedMap[dataItem.id.toString()] = currentlyChecked;
        $(treeViewNodeElement).data("postFetchChecked", currentlyChecked);
        window.setTimeout(() => {
            // We have to fetch element by ID because it has been recreated at this point
            $("#" + checkBoxId).prop("checked", currentlyChecked);
        }, 0);
    }
    getCheckBoxId($treeViewNode) {
        return $treeViewNode.find(">.k-in >.ftCheckBox").attr("id");
    }
    restoreCheckedState() {
        let that = this;
        let checkedIds = that.m_$treeView.data("checkedIds");
        if (checkedIds) {
            $.each(checkedIds, function (idx, id) {
                that.m_$treeView.find("input[data-ftid='" + id + "']").prop("checked", true);
            });
        }
    }
    getRawCheckedNames() {
        let that = this;
        let checkedNames = [];
        $.each(that.m_$treeView.find("input.ftCheckBox:checked"), function (idx, checkbox) {
            checkedNames.push($(this).next("label.ftCbLabel").text());
        });
        return checkedNames;
    }
    getRawCheckedIds() {
        let that = this;
        let checkedNodes = [];
        $.each(that.m_$treeView.find("input.ftCheckBox:checked"), function (idx, checkbox) {
            checkedNodes.push($(this).attr("data-ftid"));
        });
        return checkedNodes;
    }
    selectById(id) {
        if (!id)
            this.m_$treeView.data("kendoTreeView").select($());
        else
            this.m_$treeView.data("kendoTreeView").select($("input.ftCheckBox[data-ftid='" + id + "']"));
    }
    selectByContainedText(text) {
        let found = false;
        let that = this;
        if (text) {
            let lower = text.toLowerCase();
            $("label.ftCbLabel").each(function () {
                let cur = $(this);
                if (cur.text().toLowerCase().indexOf(lower) >= 0) {
                    let id = cur.prev("input.ftCheckBox").attr("data-ftid");
                    that.selectById(id);
                    that.scrollToId(id);
                    found = true;
                    return false;
                }
            });
        }
        return found;
    }
    scrollToId(id) {
        if (!id)
            this.m_$treeView.scrollTop(0);
        else {
            let item = $("input.ftCheckBox[data-ftid='" + id + "']").closest(".k-item");
            if (item.length === 1)
                item[0].scrollIntoView();
        }
    }
}
exports.TreePicker = TreePicker;
